<template>
    <div>
        <small>代表者姓（漢）</small>
        <b-form-input
            v-model="value.profile_representative_last"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_representative_last')" />

        <small>代表者名（漢）</small>
        <b-form-input
            v-model="value.profile_representative_first"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_representative_first')" />

        <small>会社名/屋号</small>
        <b-form-input
            v-model="value.profile_company"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_company')" />

        <small>電話</small>
        <b-form-input
            v-model="value.profile_tel"
            size="sm"
            type="tel"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_tel')" />

        <small>メール</small>
        <b-form-input
            v-model="value.profile_email"
            size="sm"
            type="email"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_email')" />

        <small>郵便番号</small>
        <b-form-input
            v-model="value.profile_address_zip"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_address_zip')" />

        <small>都道府県(漢)</small>
        <SelectPrefecture
            v-model="value.profile_address_prefecture"
            size="sm"
            />
        <input-error :errors="$utils.get(error, 'profile_address_prefecture')" />

        <small>市長区村（漢）</small>
        <b-form-input
            v-model="value.profile_address_city"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_address_city')" />

        <small>以降の住所（漢）</small>
        <b-form-input
            v-model="value.profile_address_line"
            size="sm"
            type="text"
            >
        </b-form-input>
        <input-error :errors="$utils.get(error, 'profile_address_line')" />


        <template v-if="auth_level >= '300'">
            <small>セゾン顧客番号</small>
            <b-form-input
                v-model="value.saison_customer_number"
                size="sm"
                type="text"
                >
            </b-form-input>
            <input-error :errors="$utils.get(error, 'saison_customer_number')" />

            <div class="text-right">
                <a
                    href="javascript:void(0)"
                    @click="$utils.set(value, { saison_customer_number: 'SKIP' })"
                    >
                    請求対象外
                </a>
            </div>

            <small>まるなげユーザーID</small>
            <b-form-input
                v-model="value.marunage_user_id"
                size="sm"
                type="text"
                >
            </b-form-input>
            <input-error :errors="$utils.get(error, 'marunage_user_id')" />
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import UserSettingInfo from '@/components/UserSettingInfo.vue'
import SelectPrefecture from '@/components/SelectPrefecture.vue'

export default {
    components: {
        GridPage,
        Item,
        ItemBadges,
        ItemThumb,
        UserSettingInfo,
        SelectPrefecture,
    },
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        error: {
            type: Object,
            required: false,
            default() {
                return {}
            },
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {}
    },
    watch: {
    },
    mounted() {
    },
    destroyed() {
    },
    methods: {
    },
}
</script>

